__turbopack_context__.v({
  "asset": "CHEUPG_asset",
  "caption": "CHEUPG_caption",
  "card": "CHEUPG_card",
  "category": "CHEUPG_category",
  "comingSoon": "CHEUPG_comingSoon",
  "comingSoonBadge": "CHEUPG_comingSoonBadge",
  "description": "CHEUPG_description",
  "landscape": "CHEUPG_landscape",
  "media": "CHEUPG_media",
  "mediaFrame": "CHEUPG_mediaFrame",
  "portrait": "CHEUPG_portrait",
  "square": "CHEUPG_square",
  "tag": "CHEUPG_tag",
  "tags": "CHEUPG_tags",
  "title": "CHEUPG_title",
  "video": "CHEUPG_video",
});
